import Hero from "../components/Hero";
import HeroImage from "../../assets/images/New4.jpg";
import AboutUsImage from "../../assets/images/Morris-about-us-image.jpg";
import "../../css/AboutUs.css";
import ButtonSecondary from "../components/ButtonSecondary";
import { useNavigate } from "react-router-dom";

const AboutUs = () => {
    const navigate = useNavigate();
    return (
      <div className="about-us-page">
        <Hero
          title="About Us"
          backgroundImage={HeroImage}
          titleAlign="center"
          subtitleAlign="center"
          lightOverlay={true}
        />
        <div className="primary-background-container-content  row-center">
          <div className="about-us-content">
            <h2 className="light">Morris Williams-Brown</h2>
            <p>
              Morris Williams-Brown is a Lifestyle Financial Planner with a
              passion for helping professionals, particularly doctors, surgeons
              and healthcare specialists, to take control of their finances and
              turn their ambitions into reality. Whether it’s bareback horse
              riding across the Mongolian Steppe or planning for early
              retirement, Morris is driven to help clients achieve the goals
              that matter most to them.
            </p>
            <p>
              Before transitioning into financial planning, Morris spent two
              decades in the medical devices sector, working closely with the
              NHS and other healthcare professionals. This experience gave him a
              deep appreciation for the unique pressures facing clinicians, as
              well as a first-hand understanding of how they balance NHS and
              private work. Throughout his career, he has built long-term,
              trusted relationships by prioritising integrity, empathy, and
              results.
            </p>
            <p>
              Morris’s interest in financial planning began with managing his
              own personal finances. Inspired by the value he discovered, he saw
              an opportunity to bring the same clarity and confidence to the
              people he had worked alongside for years. Today, he brings a
              holistic, lifestyle-focused approach to financial planning—helping
              clients align their money with their lives, not the other way
              around.
            </p>
            <p>
              With a unique combination of industry insight, real-world
              experience, and a genuine desire to help others, Morris offers
              tailored, practical advice that supports his clients in building
              the futures they deserve.
            </p>
            <ButtonSecondary text="CONTACT US" variant="primary" onClick={() => navigate("/contact")} />
          </div>
          <img
            src={AboutUsImage}
            alt="Morris Williams-Brown"
            className="about-us-image"
          />
        </div>
      </div>
    );
}

export default AboutUs;